import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuizPrize} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class QuizPrizeService implements CrudService<UmpireQuizPrize> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireQuizPrize[]>> {
    return this.http
      .get('/quiz_prizes', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizPrize>> {
    return this.http
      .get(`/quiz_prizes/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/quiz_prizes/${id}`);
  }

  create(
    body: Partial<UmpireQuizPrize>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizPrize>> {
    return this.http.post<JsonApiResponse<UmpireQuizPrize>>(
      '/quiz_prizes',
      serialize({stuff: body}),
      {
        params: objectToHttpParams(params),
      },
    );
  }

  update(
    body: Partial<UmpireQuizPrize>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizPrize>> {
    return this.http
      .patch<JsonApiResponse<UmpireQuizPrize>>(
        `/quiz_prizes/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
